/**
 * Client script injected into the preview iframe to enable:
 * 1. Smooth, flicker-free DOM synchronization via postMessage
 * 2. Bi-directional section scrolling and highlight outlines
 * 3. Section click event reporting back to the dashboard editor
 * 4. Keyboard shortcuts (Escape to exit fullscreen)
 */
export const INJECTED_PREVIEW_BRIDGE = `
<script id="__profolio_bridge__">
(function() {
  function syncDocument(newHtml) {
    if (!newHtml || typeof newHtml !== "string") return;
    try {
      var parser = new DOMParser();
      var newDoc = parser.parseFromString(newHtml, "text/html");

      // 1. Update Title
      if (newDoc.title && document.title !== newDoc.title) {
        document.title = newDoc.title;
      }

      // 2. Update Head (Fonts and CSS)
      var curHead = document.head;
      var newHead = newDoc.head;

      var curLinks = Array.prototype.slice.call(curHead.querySelectorAll('link[rel="stylesheet"]'));
      var newLinks = Array.prototype.slice.call(newHead.querySelectorAll('link[rel="stylesheet"]'));
      var curHref = curLinks.map(function(l) { return l.getAttribute("href"); }).join("|");
      var newHref = newLinks.map(function(l) { return l.getAttribute("href"); }).join("|");

      if (curHref !== newHref) {
        curLinks.forEach(function(l) { l.parentNode.removeChild(l); });
        newLinks.forEach(function(l) { curHead.appendChild(l.cloneNode(true)); });
      }

      var curStyles = Array.prototype.slice.call(curHead.querySelectorAll("style"));
      var newStyles = Array.prototype.slice.call(newHead.querySelectorAll("style"));
      var curCss = curStyles.map(function(s) { return s.textContent; }).join("");
      var newCss = newStyles.map(function(s) { return s.textContent; }).join("");

      if (curCss !== newCss) {
        curStyles.forEach(function(s) { s.parentNode.removeChild(s); });
        newStyles.forEach(function(s) { curHead.appendChild(s.cloneNode(true)); });
      }

      // 3. Update Body
      var scrollY = window.scrollY;
      if (document.body.className !== newDoc.body.className) {
        document.body.className = newDoc.body.className;
      }

      var incomingBridge = newDoc.body.querySelector("#__profolio_bridge__");
      if (incomingBridge && incomingBridge.parentNode) {
        incomingBridge.parentNode.removeChild(incomingBridge);
      }

      document.body.innerHTML = newDoc.body.innerHTML;
      window.scrollTo(0, scrollY);
      if (typeof window.__profolioInitAll === "function") {
        window.__profolioInitAll();
      } else if (typeof window.__profolioInitScrollObservers === "function") {
        window.__profolioInitScrollObservers();
      }
    } catch (e) {
      document.body.innerHTML = newHtml;
      if (typeof window.__profolioInitAll === "function") {
        window.__profolioInitAll();
      } else if (typeof window.__profolioInitScrollObservers === "function") {
        window.__profolioInitScrollObservers();
      }
    }
  }

  window.addEventListener("message", function(event) {
    if (event.source !== window.parent) return;

    if (event.data && event.data.type === "UPDATE_HTML" && typeof event.data.html === "string") {
      syncDocument(event.data.html);
    }

    if (event.data && event.data.type === "SCROLL_TO_SECTION" && typeof event.data.sectionId === "string") {
      var el = document.getElementById(event.data.sectionId);
      if (el) {
        el.scrollIntoView({ behavior: "smooth", block: "start" });
        var originalOutline = el.style.outline;
        var originalOutlineOffset = el.style.outlineOffset;
        var originalTransition = el.style.transition;
        el.style.transition = "outline 0.3s ease";
        el.style.outline = "2px solid var(--site-primary, #2563eb)";
        el.style.outlineOffset = "4px";
        setTimeout(function() {
          el.style.outline = originalOutline;
          el.style.outlineOffset = originalOutlineOffset;
          setTimeout(function() {
            el.style.transition = originalTransition;
          }, 300);
        }, 1500);
      }
    }
  });

  window.addEventListener("keydown", function(e) {
    if (e.key === "Escape") {
      window.parent.postMessage({ type: "EXIT_FULLSCREEN" }, "*");
    }
  });

  document.addEventListener("click", function(e) {
    var target = e.target;
    // Intercept multi-page navigation links
    var navEl = target;
    while (navEl && navEl !== document.body) {
      if (navEl.getAttribute && navEl.getAttribute("data-nav-slug") !== null) {
        e.preventDefault();
        var navSlug = navEl.getAttribute("data-nav-slug") || "";
        window.parent.postMessage({ type: "PREVIEW_NAVIGATE", slug: navSlug }, "*");
        return;
      }
      navEl = navEl.parentNode;
    }

    var sectionEl = target;
    while (sectionEl && sectionEl !== document.body) {
      if (sectionEl.tagName && sectionEl.tagName.toLowerCase() === "section" && sectionEl.id) {
        window.parent.postMessage({ type: "SECTION_CLICKED", sectionId: sectionEl.id }, "*");
        break;
      }
      sectionEl = sectionEl.parentNode;
    }
  });

  // Notify parent dashboard that the preview bridge is mounted and ready for sync
  try {
    window.parent.postMessage({ type: "PREVIEW_READY" }, "*");
  } catch (err) {}
})();
</script>
`;
